import { Injectable } from '@angular/core';
import { EPlatform, EPlatformFeature } from '@enums/campaign.enum';
import { camelCase } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class IconUtilitiesService {
  private static readonly platformFeatureIconMap = {
    [EPlatformFeature.facebookPost]: 'icons/facebook.svg',
    [EPlatformFeature.facebookVideo]: 'icons/facebook.svg',
    [EPlatformFeature.instagramPost]: 'icons/instagram.svg',
    [EPlatformFeature.instagramReel]: 'icons/instagram-reel.svg',
    [EPlatformFeature.instagramStory]: 'icons/instagram-story.svg',
    [EPlatformFeature.tiktokPost]: 'icons/tiktok.svg',
    [EPlatformFeature.twitchStream]: 'icons/twitch.svg',
    [EPlatformFeature.xPost]: 'icons/x-post.svg',
    [EPlatformFeature.youtubeShort]: 'icons/youtube-shorts.svg',
    [EPlatformFeature.youtubeStream]: 'icons/youtube.svg',
    [EPlatformFeature.youtubeVod]: 'icons/youtube.svg',
    [EPlatform.instagram]: 'icons/instagram.svg',
    [EPlatform.tiktok]: 'icons/tiktok.svg',
    [EPlatform.twitch]: 'icons/twitch.svg',
    [EPlatform.youtube]: 'icons/youtube.svg',
  };

  public static getPlatformFeatureIcon(platformFeature: string): string {
    const platformFeatureEnum = camelCase(platformFeature) as EPlatformFeature;

    return this.platformFeatureIconMap[platformFeatureEnum] ?? 'icons/image-placeholder.svg';
  }
}
